
  import { css } from 'lit';
  export const styles = css`:host{--focus-color: var(--ig-splitter-focus-color, var(--ig-secondary-500));--ig-theme: material;--ig-theme-variant: light}`;
  